import { render, staticRenderFns } from "./divisions.vue?vue&type=template&id=319c3170&"
import script from "./divisions.vue?vue&type=script&lang=js&"
export * from "./divisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports